module.exports = __webpack_public_path__ + "static/img/sensorMq2-1.7a69d33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/sensorMq2-1.svg
// module id = tE7t
// module chunks = 0